<ng-container *ngIf="showHeader">
  <img class="banner-img center-block div-print" src="https://gestionatupyme-public.s3.amazonaws.com/banner.png" alt=""/>
</ng-container>

<mat-card class="simple-card mx-auto">
  <mat-card-content>
    <div class="row">

      <div class="col-12 d-flex justify-content-between" *ngIf="!fromConsolidado && showHeader">
        <h1>Reporte VehÍculos</h1>
        <button mat-flat-button 
          class="custom-button-primary no-print"
          [printTitle]='"Vehiculos_"+(rut | rutFormat)+"_"+today'
          [useExistingCss]="true"
          printSectionId="print-section"
          ngxPrint
        >
          <mat-icon 
            aria-hidden="false" 
            aria-label="Icono de descarga" 
            fontIcon="get_app" 
            class="icon-download mr-3"
          ></mat-icon>
          Descargar Resultado
        </button>
      </div>

      <div class="col-12" *ngIf="fromConsolidado && showHeader">
        <h1>Reporte VehÍculos</h1>
      </div>

      <div class="col-12 my-3" *ngIf="showHeader">
        <mat-chip-set aria-label="Rut principal">
          <mat-chip class="chip-rut"><strong>RUT:</strong> {{content.vehiculoReporte.datosBasicosSolicitud.Rut | number: '1.0-0'}}-{{content.vehiculoReporte.datosBasicosSolicitud.DV | uppercase}}</mat-chip>
        </mat-chip-set>
      </div>

      <div class="col-12">
        <mat-card>
          <mat-card-header>
            <mat-card-title class="font-size-title-card">
              <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
              <strong>Información Básica</strong>
              <p class="d-inline fecha_size ml-2" *ngIf="fromConsolidado">({{content.vehiculoReporte?.datosBasicosSolicitud?.FechaReporte | date: 'dd-MM-yyyy'}})</p>
            </mat-card-title>
          </mat-card-header>
        
          <mat-card-content>

            <div class="row p-5">
              <div class="col-12 border mx-auto">
                <table mat-table [dataSource]="datosBasicos" class="info-basica-table">
                  <ng-container matColumnDef="name">
                    <th mat-cell *matCellDef="let element" class="cell-font-size">{{element.name}}</th>
                  </ng-container>
                
                  <ng-container matColumnDef="value">
                    <td mat-cell *matCellDef="let element" class="cell-font-size">
                      <ng-container [ngSwitch]="element.name">
                        <ng-container *ngSwitchCase="'Número Total Vehículos'">
                          {{element.value || element.value == 0 ? (element.value | number: '1.0-0') : element.value}}
                        </ng-container>
                        <ng-container *ngSwitchCase="'Valor Total Vehículos'">
                          M$ {{element.value || element.value == 0 ? (element.value | number: '1.0-0') : element.value}}
                        </ng-container>
                        <ng-container *ngSwitchCase="'Rut'">
                          {{element.value ? (element.value | rutFormat) : ''}}
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                          {{element.value}}
                        </ng-container>
                      </ng-container>
                    </td>
                  </ng-container>
                
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns;"
                  ></tr>
                </table>
              </div>
            </div>

          </mat-card-content>
        </mat-card>
      </div>

      <div class="col-12 mt-5 mb-3">
        <mat-card>
          <mat-card-header>
            <mat-card-title class="font-size-title-card">
              <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
              <strong>Detalles</strong>
              <p class="d-inline fecha_size ml-2" *ngIf="fromConsolidado">({{content.vehiculoReporte?.datosBasicosSolicitud?.FechaReporte | date: 'dd-MM-yyyy'}})</p>
            </mat-card-title>
          </mat-card-header>
        
          <mat-card-content>

            <div class="row p-5" *ngIf="content?.vehiculoReporte?.vehiculos?.listadoVehiculos.length > 0; else noData">
              <div class="col-12 border mx-auto px-0">

                <div class="table-responsive">
                  <table mat-table [dataSource]="tableVehiculos" class="custom-print-table">
                    <ng-container matColumnDef="ppu">
                      <th mat-header-cell *matHeaderCellDef> {{vehiculosText['ppu']}} </th>
                      <td mat-cell *matCellDef="let element"> {{element.ppu}} </td>
                    </ng-container>
                    <ng-container matColumnDef="marca">
                      <th mat-header-cell *matHeaderCellDef> {{vehiculosText['marca']}} </th>
                      <td mat-cell *matCellDef="let element"> {{element.marca}} </td>
                    </ng-container>
                    <ng-container matColumnDef="modelo">
                      <th mat-header-cell *matHeaderCellDef> {{vehiculosText['modelo']}} </th>
                      <td mat-cell *matCellDef="let element"> {{element.modelo}} </td>
                    </ng-container>
                    <ng-container matColumnDef="color">
                      <th mat-header-cell *matHeaderCellDef> {{vehiculosText['color']}} </th>
                      <td mat-cell *matCellDef="let element"> {{element.color}} </td>
                    </ng-container>
                    <ng-container matColumnDef="tipo_vehiculo">
                      <th mat-header-cell *matHeaderCellDef> {{vehiculosText['tipo_vehiculo']}} </th>
                      <td mat-cell *matCellDef="let element"> {{element.tipo_vehiculo}} </td>
                    </ng-container>
                    <ng-container matColumnDef="anio_fabricacion">
                      <th mat-header-cell *matHeaderCellDef> {{vehiculosText['anio_fabricacion']}} </th>
                      <td mat-cell *matCellDef="let element"> {{element.anio_fabricacion}} </td>
                    </ng-container>
                    <ng-container matColumnDef="ultima_transferencia">
                      <th mat-header-cell *matHeaderCellDef> {{vehiculosText['ultima_transferencia']}} </th>
                      <td mat-cell *matCellDef="let element"> {{element.ultima_transferencia}} </td>
                    </ng-container>
                    <ng-container matColumnDef="numero_motor">
                      <th mat-header-cell *matHeaderCellDef> {{vehiculosText['numero_motor']}} </th>
                      <td mat-cell *matCellDef="let element"> {{element.numero_motor}} </td>
                    </ng-container>
                    <ng-container matColumnDef="numero_chasis">
                      <th mat-header-cell *matHeaderCellDef> {{vehiculosText['numero_chasis']}} </th>
                      <td mat-cell *matCellDef="let element"> {{element.numero_chasis}} </td>
                    </ng-container>
                    <ng-container matColumnDef="tasacion">
                      <th mat-header-cell *matHeaderCellDef> {{vehiculosText['tasacion']}} </th>
                      <td mat-cell *matCellDef="let element"> {{element.tasacion | number: '1.0-0'}} </td>
                    </ng-container>
                  
                    <tr mat-header-row *matHeaderRowDef="displayedColumnsVehiculos"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsVehiculos;"></tr>
                  </table>
                </div>
                
              </div>
            </div>

            <ng-template #noData>
              <div class="row p-5">
                <div class="col-12 border mx-auto px-0">

                  <div class="table-responsive">
                    <table mat-table class="">
                      <ng-container matColumnDef="ppu">
                        <th mat-header-cell *matHeaderCellDef> {{vehiculosText['ppu']}} </th>
                      </ng-container>
                      <ng-container matColumnDef="marca">
                        <th mat-header-cell *matHeaderCellDef> {{vehiculosText['marca']}} </th>
                      </ng-container>
                      <ng-container matColumnDef="modelo">
                        <th mat-header-cell *matHeaderCellDef> {{vehiculosText['modelo']}} </th>
                      </ng-container>
                      <ng-container matColumnDef="color">
                        <th mat-header-cell *matHeaderCellDef> {{vehiculosText['color']}} </th>
                      </ng-container>
                      <ng-container matColumnDef="tipo_vehiculo">
                        <th mat-header-cell *matHeaderCellDef> {{vehiculosText['tipo_vehiculo']}} </th>
                      </ng-container>
                      <ng-container matColumnDef="anio_fabricacion">
                        <th mat-header-cell *matHeaderCellDef> {{vehiculosText['anio_fabricacion']}} </th>
                      </ng-container>
                      <ng-container matColumnDef="ultima_transferencia">
                        <th mat-header-cell *matHeaderCellDef> {{vehiculosText['ultima_transferencia']}} </th>
                      </ng-container>
                      <ng-container matColumnDef="numero_motor">
                        <th mat-header-cell *matHeaderCellDef> {{vehiculosText['numero_motor']}} </th>
                      </ng-container>
                      <ng-container matColumnDef="numero_chasis">
                        <th mat-header-cell *matHeaderCellDef> {{vehiculosText['numero_chasis']}} </th>
                      </ng-container>
                      <ng-container matColumnDef="tasacion">
                        <th mat-header-cell *matHeaderCellDef> {{vehiculosText['tasacion']}} </th>
                      </ng-container>
                    
                      <tr mat-header-row *matHeaderRowDef="displayedColumnsVehiculos"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumnsVehiculos;"></tr>
                    </table>
                  </div>

                </div>
              </div>
            </ng-template>

          </mat-card-content>
        </mat-card>
      </div>

    </div>
  </mat-card-content>
</mat-card>
